import { useMiscUI } from "../contexts/MiscUI/MiscUIProvider";

export default function useGlobalLoading() {
  const [, dispatch] = useMiscUI();

  const beginLoading = () => {
    dispatch({ type: "SET_GLOBAL_LOADING", payload: true });
  };

  const endLoading = () => {
    dispatch({ type: "SET_GLOBAL_LOADING", payload: false });
  };

  const withLoading = async (promise: Promise<unknown>) => {
    beginLoading();

    try {
      return await promise;
    } finally {
      endLoading();
    }
  };

  return { withLoading, beginLoading, endLoading };
}
